import React from 'react';

export default class Button extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      disabled: props.disabled
    };
  }

  componentWillReceiveProps(nextProps) {
    if(this.props.disabled !== nextProps.disabled) {
      this.setState({disabled: nextProps.disabled});
    }
  }

  handleButtonClick = (event) => {
    if(this.props.disableOnclick === true) {
      this.setState({disabled: true});
    }
    event.preventDefault();
    this.props._onClick(event, this.props.apiUrl);
  }

  render() {
    const {bsClass, ariaLabel, iconClass,translatedText} = this.props;
    let iconJsx = '';
    if (iconClass) {
      iconJsx = (<i className={`icon ${iconClass}`}></i>)
    }

    return (
      <button aria-label={ariaLabel || translatedText}
      className={bsClass}
      disabled={this.state.disabled === "true" || this.state.disabled === true}
      onClick={this.handleButtonClick}
      id={this.props.id}
      >{iconJsx} {translatedText}</button>
    )
  }
}

Button.defaultProps = {
  disableOnclick: false,
  disabled: "false",
  text: "Button"
}



// WEBPACK FOOTER //
// ./src/components/common/Btn/index.js